/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { useTableKeyboardNavigation as n } from "@progress/kendo-react-data-tools";
import { useContextMenuHandler as o } from "../hooks.mjs";
const u = (t) => {
  const e = n(t.id);
  return {
    onContextMenu: o(t.dataItem),
    ...e
  };
};
export {
  u as useDetailCellClientTdProps
};
